import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import parse from 'html-react-parser';

import Container from '../../containers/Container';
import Grid from '../../components/Grid';
import { ReactComponent as LogoSvg } from '../../res/logo_blanc.svg';
import styles from './styles';

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.onClickLogo = this.onClickLogo.bind(this);
  }

  onClickLogo() {
    const { data } = this.props;
    window.open(data['site-ush'], '_blank');
  }

  render() {
    const { classes, data } = this.props;
    const block = data.footer;
    return (
      <Container className={classes.container} id="footer">
        <Grid spacing={3}>
          <Grid.Item key="logo" xs={12} sm={12} md={2}>
            <LogoSvg className={classes.logo} onClick={this.onClickLogo} />
          </Grid.Item>
          <Grid.Item key="p1" xs={12} sm={12} md={5}>
            <div className={classes.p1}>
              <Typography className={classes.title}>{parse(block['p1-title'])}</Typography>
              <Typography>{parse(block['p1-desc'])}</Typography>
            </div>
          </Grid.Item>
          <Grid.Item key="p2" xs={12} sm={12} md={5}>
            <div className={classes.p2}>
              <Typography className={classes.title}>{parse(block['p2-title'])}</Typography>
              <Typography>{parse(block['p2-desc'])}</Typography>
            </div>
          </Grid.Item>
        </Grid>
      </Container>
    );
  }
}

Footer.propTypes = {
  data: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
